var map = {
	"./nav-color-gold.svg": 174,
	"./nav-color-multicolor.svg": 175,
	"./nav-color-palladium.svg": 236,
	"./nav-color-platinum.svg": 176,
	"./nav-color-redgold.svg": 116,
	"./nav-color-rosegold.svg": 177,
	"./nav-color-signature.svg": 178,
	"./nav-color-silver.svg": 258,
	"./nav-color-whitegold.svg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;